import { PrescriptionSelection } from './api';
import { SelectedDoctor } from './doctor';

export enum TaxFilingStatus {
  MarriedFilingJointly = 'joint',
  MarriedFilingSeparately = 'separately',
  Single = 'individual',
}

export type ChoiceComparison = {
  additionalBenefitsPref: string;
  highRxCostsQ: string;
  lowOOPPref: string;
  needsChronicSupport: string;
  needsTravelCare: string;
};

export type EligibilityDates = {
  bornFirstDay: boolean;
  earlyIEPCutoff: Date;
  firstCoverageStartDate: Date;
  iepEndDate: Date;
  iepStartDate: Date;
};

export type MedSuppEligibilityDates = {
  startDate: Date;
  endDate: Date;
};

export interface PersistedUser {
  additional_benefits_pref: string;
  birthdate: string;
  citizen: string;
  collecting_rr: string;
  collecting_ss: string;
  county_fips: string;
  current_insurance_exp_q: string;
  current_insurance_q: string;
  currently_married: string;
  doctors: SelectedDoctor[];
  file_taxes: string;
  gender: string;
  health_needs_hospital: string;
  health_needs_primary_care: string;
  health_needs_specialist: string;
  high_rx_costs_q: string;
  hundred_plus_employees: string;
  illness_disability: string;
  income: number;
  lives_in_us: string;
  low_oop_pref: string;
  needs_chronic_support: string;
  needs_travel_care: string;
  plan_selections: PlanSelection[];
  pref_ad_benefits: string;
  pref_ad_benefits_list: string;
  pref_med_needs: string;
  pref_ongoing_rx: string;
  prescription_selections: PrescriptionSelection[];
  prev_spouse_status: string;
  prev_spouse_worked_10_yrs: string;
  tobacco: boolean;
  twenty_plus_employees: string;
  viewed_contents: ViewedContent[];
  worked_10_yrs: string;
  worked_30_quarters: string;
  zipcode: string;
}

export interface PlanSelection {
  plan_id: string;
}

export type UsageAndPreference = {
  prefAdBenefits: Array<string>;
  prefAdBenefitsList: Array<string>;
  prefMedNeeds: string;
  prefOngoingRx: string;
};

export type UserDynamicValues = {
  birthdate: string;
  currentlyMarried: boolean | null;
  income: number;
  usesTobacco: string;
  zipCode: string;
  countyFips: string;
  usesHearingAids: string;
  usesDentalOrVision: string;
  iepStatus: string;
  planYear: string;
  nextPlanYear: string;
  twoYearsAgo: string;
  partnerName: string;
  partnerPhone: string;
  sexAtBirth: string;
  specialistVisits: string;
  hospitalVisits: string;
  numberOfPrescriptions: number;
  endInitialEnrollmentDate: string;
  initialEligibilityDate: string;
  isEligibleForMedSupp: boolean;
  planEffectDate: string;
  postEligibilityDate: string;
  postEligibilityPlanEffectDate: string;
  endDateSpecialEnrollment: string;
  highCostMedSupp: string | undefined;
  lowCostMedSupp: string | undefined;
  costUnexpectedExpense: string | undefined;
  lowCostHMO: string | undefined;
  amountSavedHMO: string | undefined;
  maPlansAvailable: boolean;
  bestPlanOption: string;
  bestPlanCostDifference: string;
  bestPlanCostDifferenceMonthly: string;
  isLoggedIn: boolean;
  medicareEducationCompletionCount: number;
  carrierCount: number | '';
  productCount: number | '';
  maOnlyCount: number | '';
  maPdCount: number | '';
  maSubCount: number | '';
  pdpCount: number | '';
  medSupCount: number | '';
};

export interface UserHealthNeeds {
  hospital: string;
  primaryCare: string;
  specialist: string;
}

export interface ViewedContent {
  content_slug: string;
}
